import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';

/**
 * Login to Explore More Products Card Component
 * Displays when user has reached the product view limit (4 products) and needs to login
 */
const LoginExploreCard = ({ totalProducts = 0 }) => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    // Don't store redirect - will go to home after login
    navigate('/login');
  };

  return (
    <div className="login-explore-card">
      <h3 className="login-explore-card-title">
        🔒 Login to Explore More Products
      </h3>
      <p className="login-explore-card-message">
        You've viewed 4 products. Sign in to see all {/* {totalProducts}*/} results. 
      </p>
      <button
        onClick={handleLoginClick}
        className="login-explore-card-btn"
      >
        Login to Continue
      </button>
    </div>
  );
};

export default LoginExploreCard;

